$(function () {
    window.setTimeout(window.onload = function () {
        $('input').not('[type=submit]').val('');
    }, 500);
});